// extracted by mini-css-extract-plugin
module.exports = {"hotelFacility":"HotelFacility_hotelFacility__EBsb2","facilityTooltip":"HotelFacility_facilityTooltip__1VGS5"};